export const SUCCESS = 'Success'
export const WARNING = 'Warning'
export const ERROR = 'Error'

export const CourierStatusSubmitFailedToCourier = 'submit-failed-to-courier'
export const CourierStatusSubmittedToCourier = 'submitted-to-courier'
export const CourierStatusRejectedByCourier = 'rejected-by-courier'
export const CourierStatusAcceptedByCourier = 'accepted-by-courier'
export const CourierStatusFailedDeliveryToReceipt = 'failed-delivery-to-receipt'
export const CourierStatusDeliveredToReceipt = 'delivered-to-receipt'
export const CourierStatusOpenedByReceipt = 'opened-by-receipt'

export const convertCourierStatusToMessageStatus = (value: string) => {
  switch (value) {
    case CourierStatusSubmittedToCourier:
    case CourierStatusAcceptedByCourier:
    case CourierStatusDeliveredToReceipt:
    case CourierStatusOpenedByReceipt:
      return SUCCESS
    case CourierStatusSubmitFailedToCourier:
    case CourierStatusRejectedByCourier:
    case CourierStatusFailedDeliveryToReceipt:
      return ERROR
    default:
      return WARNING
  }
}

export const extractErrorMessage = (errorStr: string) => {
  const defaultError = 'Error while sending email'
  const match = errorStr.match(/Error:\s*(\{.*\})/)

  if (match) {
    try {
      const errorJson = match[1] ? JSON.parse(match[1]) : {}
      return errorJson.message || defaultError
    } catch (e) {
      return defaultError
    }
  }

  return defaultError
}
